import { render, staticRenderFns } from "./GetFunded.vue?vue&type=template&id=5d36e3a4&"
import script from "./GetFunded.vue?vue&type=script&lang=js&"
export * from "./GetFunded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports